import React from 'react'
import { getIcon } from '../../shared/icons/getIcon'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const ContentList = ({ items }) => {
  return (
    <div className="dealmed-content-list">
      <ul className="dealmed-content-list__list">
        {items.map((item, index) => {
          return (
            <li key={index} className="dealmed-content-list__item">
              <div className="dealmed-content-item">
                <div className="dealmed-content-item__asset">
                  <span className="dealmed-content-item__icon-wrapper">
                    {getIcon(item.fields.icon)}
                  </span>
                </div>
                <div
                  className="dealmed-content-item__content"
                  // dangerouslySetInnerHTML={{ __html: item.fields.content }}
                >
                  {/* /> */}
                  {documentToReactComponents(item.fields.content)}
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ContentList
